import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/breuerklimaattechniek-website/breuerklimaattechniek-website/apps/website/src/app/advies/[slug]/BlogPostClient.tsx");
